<template>
<div>
    <div class="selectbank delmas">
        <p class="title">Select Card</p>

        <form action="">
            <div class="visa-body">
                <div :id="'image'+key" class="cover-container" :key="key" v-for="(card,key) in cards" @click.prevent="pickCard(key)">
                    <div class="cc-selector">
                        <input id="visaA" type="radio" name="credit-carda" value="visa" />
                        <label class="drinkcard-cc visaa" for="visa"></label>
                        <span class="brand-name">{{ card.issuer || card.scheme}}</span>
                        <h1>{{ $formatCard(card.number.toUpperCase()) }}</h1>
                        <img :src="'/mtn/assets/'+card.scheme.toLowerCase()+'.png'" alt="" class="cardtype">
                    </div>
                </div>
            </div>
        </form>
        <ul class="uk-slider-nav uk-dotnav">
            <li :uk-slider-item="key" :class="card_index == key ? 'uk-active' : null" v-for="(card,key) in cards" :key="card.uid" @click.prevent="pickCard(key)">
                <a :href="'#image'+key"></a>
            </li>
        </ul>

        <div class="select-card-footer">
            <a @click.prevent="triggerCardInput">
                <div class="addaccount">
                    <p><span><img src="/mtn/assets/add.png" alt=""></span> Add New Card</p>
                </div>
            </a>

            <a @click.prevent="triggerManageCard">
                <div class="addaccount">
                    <p><span><img src="/mtn/assets/add.png" alt=""></span>Manage Existing Card</p>
                </div>
            </a>
        </div>
    </div>

    <slot name="amount" />

    <button v-if="selected_card" @click.prevent="makePayment" type="button" class=" viabutton submit">Proceed</button>
</div>
</template>

<script>
export default {
    props: {
        redirectToThirdParty: {
            type: Boolean,
            required: true,
            default: false,
        },
        client_info: {
            type: Object,
            required: true
        },

        cards: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            loading: true,
            hoverKey: 0,
            card_index:0,
            hoverValue: '',
            hover: false,
            cardRemovalActionHover: '',
            cardRemovalActionHoverKey: '',
        }
    },
    
    methods: {
        pickCard(val) {
            this.$emit('selectCard', this.card[val]);
        },
        triggerManageCard() {
            this.$emit('triggerManageCard');
        },
        makePayment() {
            this.$emit('makePayment');
        },
        triggerCardInput() {
            this.$emit('triggerCardInput');
        },
        formatCard(str) {
            str = str.toUpperCase();
            let prefix = str.slice(0, 4),
                prefix2 = str.slice(4, 8),
                prefix3 = str.slice(8, 12),
                suffix = str.slice(10),
                main = `${prefix} ${prefix2} ${prefix3} ${suffix}`;
            return main;
        },
        hoverEffect(value, key) {
            this.hover = value
            this.hoverKey = key
        },

        cardRemovalHoverEffect(value, key) {
            this.cardRemovalActionHover = value
            this.cardRemovalActionHoverKey = key
        },
        
    },
}
</script>
